import React, { useEffect, useRef } from "react";
import NbyulaAvatarIcon from "../../../lib/components/Icons/NbyulaAvatarIcon";

function CustomChatNotification({ title, body, link, avatarSrc }) {
  const handleToastClick = () => {
    if (link) {
      window.location.href = link;
    }
  };
  const audioRef = useRef(null);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  }, [audioRef]);

  return (
    <div
      onClick={handleToastClick}
      className="flex items-center space-x-4 rounded"
    >
      {avatarSrc && avatarSrc?.length ? (
        <img
          src={avatarSrc}
          alt="User Avatar"
          className="flex flex-shrink-0 w-10 h-10 rounded-full"
        />
      ) : (
        <NbyulaAvatarIcon className="w-10 h-10" />
      )}
      <div className="text-white">
        <h4 className="font-semibold">{title}</h4>
        <p className="font-medium break-all line-clamp-1">{body}</p>
      </div>
      <audio
        src="/msg-notif.mp3"
        className="hidden"
        width="0"
        height="0"
        ref={audioRef}
      />
    </div>
  );
}

export default CustomChatNotification;
